import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { easyPeasyStore } from "./utils/data-store/store";
import { StoreProvider } from "easy-peasy";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <StoreProvider store={easyPeasyStore}>
    <App />
  </StoreProvider>
);
